import { Filter } from '@/interfaces/filter.interface'
import { APIReportDatasource } from '@/models/api/report-datasource.model'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { ReportDatasourcesServices } from '../../services/modules/report-datasources.service'

@Module
export default class ReportDatasourcesStore extends VuexModule {
    reportDatasources: object[] = []
    reportdatasourcesPaginate: object[] = []
    reportDatasourceForm: object|null = null

    @Mutation
    updateReportDatasources (newDatasources: object[]) {
        this.reportDatasources = newDatasources
    }

    @Mutation
    updateReportDatasourcesPaginate (newDatasources: object[]) {
        this.reportdatasourcesPaginate = newDatasources
    }

    @Mutation
    updateReportDatasource (newReportDatasource: object) {
        this.reportDatasourceForm = newReportDatasource
    }

    @Action
    getReportDatasources () {
        return new Promise((resolve) => {
            ReportDatasourcesServices.getReportDatasources()
                .then(resp => {
                    store.commit('updateReportDatasources', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportDatasourcesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ReportDatasourcesServices.getReportDatasourcesPaginate(newParams)
                .then(resp => {
                    store.commit('updateReportDatasourcesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportDatasourcesById (id: number) {
        return new Promise((resolve) => {
            ReportDatasourcesServices.getReportDatasourcesById(id)
                .then(resp => {
                    store.commit('updateReportDatasource', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editDatasources (params: APIReportDatasource) {
        params = new APIReportDatasource(params)
        return new Promise((resolve) => {
            if (!(params instanceof APIReportDatasource)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }
            ReportDatasourcesServices.editReportDatasources(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createDatasources (params: APIReportDatasource) {
        params = new APIReportDatasource(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIReportDatasource)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ReportDatasourcesServices.createReportDatasources(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteReportDatasources (id: number) {
        return new Promise((resolve) => {
            ReportDatasourcesServices.deleteReportDatasources(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
